export default __webpack_public_path__ + "static/support-sponsor-graficaveneta-8333bbdb92fda86388cf1120196ff99e.png";